export enum AdminRouteNames {
  Admin = 'admin',
  Home = 'admin-home',
  Analytics = 'admin-analytics',
  // Availability = 'admin-availability',
  // Services = 'admin-services',
  BusinessConfigurations = 'admin-business-configurations',
  ClientProfile = 'admin-client-profile',
  Clients = 'admin-clients',
  // `Communication` is the automations page (automations + smart-schedule tabs).
  Communication = 'admin-communication',
  // SMS broadcast campaigns (the old "send SMS" tab, now its own page).
  Campaigns = 'admin-campaigns',
  Configurations = 'admin-configurations',
  Vouchers = 'admin-vouchers',
  Payments = 'admin-payments',
  HelpCenter = 'help-center',
  Automations = 'automations',
  Shop = 'shop',
  LoyaltyProgram = 'loyalty-program',
  ReferralProgram = 'referral-program',
  Integrations = 'admin-integrations',
  ConsentForms = 'admin-consent-forms',
  Reports = 'admin-reports',
  Team = 'admin-team',
  TeamProfile = 'admin-team-profile',
  ResourceProfile = 'admin-resource-profile',
  More = 'admin-more',
  Tasks = 'admin-tasks',
  ManualCardCharge = 'admin-manual-card-charge',
}

export enum AuthRouteNames {
  AdminLogin = 'admin-login',
  CustomerLogin = 'customer-login',
  CustomerPhoneVerification = 'customer-phone-verification',
  Register = 'register',
  AiSetup = 'ai-setup',
  LoginCallback = 'logincallback',
  ResetPassword = 'reset-password',
}

export enum PlatformRouteNames {
  Panel = 'platform-panel',
}

export enum CustomerRouteNames {
  Customer = 'customer',
  Home = 'customer-home',
  Schedule = 'customer-schedule',
  AppointmentView = 'appointment-view',
  History = 'appointments-history',
}
